import gql from "graphql-tag";

export default gql`query UploadFileShares {
    uploadFileShares {
        id
        code
        subject
        expiresAt
        file {
            id
            referencelong
            department {
                id
            }
        }
    }
  }`